<template>
  <div class="flex">
    <div id="main" role="main">
      <PageSlides :slides="slides" />
    </div>
  </div>
</template>

<script>
import PageSlides from '../components/PageSlides.vue'

export default {
  name: 'Start',
  components: {
    PageSlides,
  },
  methods: {
    setDarkNav() {
      this.$store.dispatch('setDarkNav')
    },
    setWhiteNav() {
      this.$store.dispatch('setWhiteNav')
    },
    setFixedFooter() {
      this.$store.dispatch('setFixedFooter')
    },
    setDefaultFooter() {
      this.$store.dispatch('setDefaultFooter')
    },
  },
  mounted() {
    this.setWhiteNav()
    this.setFixedFooter()
  },
  beforeDestroy() {
    this.setDarkNav()
    this.setDefaultFooter()
  },
  data() {
    return {
      slides: [
        {
          headline: 'Haus Morgensonne',
          intro:
            'Wir begrüßen Sie zu erholsamen Ferien bei Familie Asal in Aitern. Unser Haus liegt in einer herrlichen Landschaft zwischen Feldberg und Belchen im Naturpark Südschwarzwald.',
          src: 'img/haus/hero_image.jpeg',
          btnText: 'Mehr erfahren',
          btnTarget: '/haus',
        },
        {
          headline: 'Ferienwohnung Landliebe',
          intro:
            'Wollen Sie mal so richtig entspannen und sich dabei rundum wohlfühlen? Unsere liebevoll und gemütlich eingerichtete Ferienwohnung lädt Sie herzlich dazu ein.',
          src: 'img/fewo_landliebe/landliebe-6374.jpeg',
          btnText: 'Mehr erfahren',
          btnTarget: '/ferienwohnung',
        },
        {
          headline: 'Die Region',
          intro: 'Aktivitäten und Erlebnisse in der Umgebung.',
          src: 'img/imp_sommer/R6__0594.jpg',
          btnText: 'Mehr erfahren',
          btnTarget: '/die-region',
        },
        {
          headline: 'Über Uns',
          intro:
            'Wir, Agnes und Hanspeter Asal mit unseren Kindern Julian, Benedikt und Johanna haben unser zu Hause auf der ruhigen und sonnigen Südseite oberhalb des Aiterner Tals auf ca. 700 m ü.M.',
          src: 'img/about/vermieter.jpg',
          btnText: 'Mehr erfahren',
          btnTarget: '/ueber-uns',
        },
      ],
    }
  },
}
</script>
